
import { useReducer } from 'react';
import { FETCH_ACTION_TYPES, fetchReducer, FetchState } from 'src/reducers/fetchReducer';
import { ChangePasswordPostResponse } from 'src/api/changePasswordAPIPost';
import { updatePassword } from 'src/api/changePasswordAPIPost';
import  SettingTypePost  from 'src/types/SettingTypePost';
import { SearchDetailsState, SEARCH_DETAILS_ACTION_TYPES } from 'src/stateProviders/searchDetailsStateProvider';
import { useSearchDetailsDispatchContext } from 'src/stateProviders/useSearchDetailsStateContext';
import showNotificationError from 'src/components/common/Notification';
import {
  notification,
  message
} from 'antd';
const initialState: FetchState<SettingTypePost> = {
  loading: false,
  error: false,
  data: null,
};


export type JobNameDispatch = {
  updateChangePassword: (values: { ischangepasswordflag: boolean }) => void;
};

const useChangePasswordPostFetch = (): [FetchState<ChangePasswordPostResponse>, JobNameDispatch] => {
  const [state, dispatch] = useReducer(fetchReducer, initialState);
  const dispatchDetailsContext = useSearchDetailsDispatchContext();
  return [
    state as FetchState<ChangePasswordPostResponse>,
    {
      updateChangePassword: async (values) => {       
        dispatch({ type: FETCH_ACTION_TYPES.loading, payload: { loading: true } });
        try {
          const response : ChangePasswordPostResponse = await updatePassword(values);
          if(response !== undefined && response.message=="" ){
            message.loading("Action in progress...", 0.5) ;
                        
            notification.warn({
              message: 'User can use same password',
              description: response.message,
              duration: 2,
            })}
          else if(response.success===true && response.message=="Your password has been changed."){
            message.loading("Action in progress...", 0.5) ;
          
           notification.success({
            message: 'Your password has been changed.',
            description: response.message,
            duration: 2,
          })
           
            dispatchDetailsContext({
              type: SEARCH_DETAILS_ACTION_TYPES.setSettingsPost,
              payload: { settingsUpdated:true } as SearchDetailsState,
            });
          }
          else if(response.success===false) {
            message.loading("Action in progress...", 0.5) ;
           
            showNotificationError(response.message);
           }          
        } catch (e) {
          dispatch({ type: FETCH_ACTION_TYPES.setError, payload: { error: e } });
        }
      },
    },
  ];
};

export default useChangePasswordPostFetch;


